var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getStores, setGeolocationDataAsync } from '../helpers/localization';
import { debugModes } from '../helpers/debug';
import { docReady } from '../helpers/doc-ready';
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match)
        return match[2];
    return false;
};
// GEOLOCATION PROMPT
class GeolocationPrompt extends HTMLElement {
    constructor() {
        super();
        this.translations = {
            shopping_in: 'Shopping in {{ countryName }}',
        };
        this.countryCode = '';
        this.countryName = '';
        if (window.thDebug.isEnabled(debugModes.geolocation)) {
            this.stores = getStores();
        }
        else {
            this.stores = getStores().filter((store) => store.enabled);
        }
        this.translations = window.thGeolocationData.t;
        const urlParams = new URLSearchParams(window.location.search);
        const manualParam = urlParams.get('m');
        if (manualParam && manualParam === '1') {
            this.cancel();
            return;
        }
        const cookie = getCookie('geolocationAccepted');
        if (JSON.parse(String(cookie)) === true)
            return;
        this.countryCode = sessionStorage.getItem('countryCode');
        this.countryName = sessionStorage.getItem('countryName');
        const targetStore = this.getTargetStore();
        if (!targetStore)
            return;
        if (this.countryCode) {
            if (targetStore.primary_domain === window.thGeolocationData.primary_domain) {
                if (window.thGeolocationData.markets) {
                    window.thGeolocationData.markets.forEach((market) => {
                        const countryCodeArray = market.codes.replace(/\s/g, '').split(',');
                        if (countryCodeArray.indexOf(this.countryCode) != -1) {
                            const currentMarket = document.documentElement.getAttribute('market');
                            if (this.countryCode != currentMarket) {
                                // If the user is not in the correct market already
                                // Redirect customer to Market
                                return this.renderMarket(market);
                            }
                        }
                        else {
                            return;
                        }
                    });
                }
            }
            else {
                this.render(targetStore);
            }
        }
    }
    getTargetStore() {
        var _a;
        const store = (_a = this.stores) === null || _a === void 0 ? void 0 : _a.find((store) => {
            if (store.defaultCountry.isoCode === this.countryCode) {
                return true;
            }
            const found = store === null || store === void 0 ? void 0 : store.availableCountries.find((country) => country.isoCode === this.countryCode);
            if (found) {
                return true;
            }
            return false;
        });
        return store;
    }
    renderMarket(market) {
        var _a, _b;
        const modalCloseButton = document.querySelector('[data-geolocation-close]');
        modalCloseButton === null || modalCloseButton === void 0 ? void 0 : modalCloseButton.addEventListener('click', () => {
            this.cancel();
        });
        // This form is the default form created by shopify to manage locations. It is important to use this as stores work different depending on the domains they have configured top level / country top level. This form manage the redirections correctly including locales
        const form = document.createElement('form');
        form.setAttribute('class', 'region-selector-modal__region--list');
        form.setAttribute('method', 'post');
        form.setAttribute('action', `https://${market.redirect_domain}/localization`);
        form.innerHTML = `
      <input type="hidden" name="form_type" value="localization"/>
      <input type="hidden" name="utf8" value="✓"/>
      <input type="hidden" name="_method" value="put"/>
      <input type="hidden" name="country_code" value="${this.countryCode}"/>
      <input type="hidden" name="return_to" value="${`https://${market.redirect_domain}/`}"/>
    `;
        this.appendChild(form);
        const fileUrlFull = document.body.getAttribute('data-file-url');
        const fileUrlArr = fileUrlFull.split('?');
        const fileUrl = fileUrlArr[0];
        const flagImageElement = document.createElement('img');
        flagImageElement.src = `https:${fileUrl}${this.countryCode}.png`;
        flagImageElement.width = 124;
        flagImageElement.height = 74;
        flagImageElement.alt = `${this.countryCode}`;
        flagImageElement.classList.add('geo-flag-image');
        const flagContainerElement = document.querySelector('[data-geolocation-flags]');
        flagContainerElement.appendChild(flagImageElement);
        const shoppingInText = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.shopping_in) ? (_b = this.translations) === null || _b === void 0 ? void 0 : _b.shopping_in : 'Shopping in';
        const storePromptContent = document.createTextNode(shoppingInText.replace('{{ countryName }}', this.countryName));
        const storePromptElement = document.querySelector('[data-geolocation-header]');
        storePromptElement.appendChild(storePromptContent);
        const ctaButtonElement = document.querySelector('[data-geolocation-change-store]');
        ctaButtonElement === null || ctaButtonElement === void 0 ? void 0 : ctaButtonElement.addEventListener('click', () => {
            this.accept(form);
        });
        const stayOnThisStoreElement = document.querySelector('[data-geolocation-stay]');
        stayOnThisStoreElement === null || stayOnThisStoreElement === void 0 ? void 0 : stayOnThisStoreElement.addEventListener('click', () => {
            this.cancel();
        });
        const modalOverlay = this.querySelector('modal-overlay');
        modalOverlay.setAttribute('open', '');
        ctaButtonElement === null || ctaButtonElement === void 0 ? void 0 : ctaButtonElement.focus();
    }
    render(store) {
        var _a, _b;
        const modalCloseButton = document.querySelector('[data-geolocation-close]');
        modalCloseButton === null || modalCloseButton === void 0 ? void 0 : modalCloseButton.addEventListener('click', () => {
            this.cancel();
        });
        // This form is the default form created by shopify to manage locations. It is important to use this as stores work different depending on the domains they have configured top level / country top level. This form manage the redirections correctly including locales
        const form = document.createElement('form');
        form.setAttribute('class', 'region-selector-modal__region--list');
        form.setAttribute('method', 'post');
        form.setAttribute('action', `https://${store.primary_domain}/localization`);
        form.innerHTML = `
      <input type="hidden" name="form_type" value="localization"/>
      <input type="hidden" name="utf8" value="✓"/>
      <input type="hidden" name="_method" value="put"/>
      <input type="hidden" name="country_code" value="${this.countryCode}"/>
      <input type="hidden" name="return_to" value="${`https://${store.primary_domain}/`}"/>
    `;
        this.appendChild(form);
        const fileUrlFull = document.body.getAttribute('data-file-url');
        const fileUrlArr = fileUrlFull.split('?');
        const fileUrl = fileUrlArr[0];
        const flagImageElement = document.createElement('img');
        flagImageElement.src = `https:${fileUrl}${this.countryCode}.png`;
        flagImageElement.width = 124;
        flagImageElement.height = 74;
        flagImageElement.alt = `${this.countryCode}`;
        flagImageElement.classList.add('geo-flag-image');
        const flagContainerElement = document.querySelector('[data-geolocation-flags]');
        flagContainerElement.appendChild(flagImageElement);
        const shoppingInText = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.shopping_in) ? (_b = this.translations) === null || _b === void 0 ? void 0 : _b.shopping_in : 'Shopping in';
        const storePromptContent = document.createTextNode(shoppingInText.replace('{{ countryName }}', this.countryName).replace('{{ regionGroup }}', store.name));
        const storePromptElement = document.querySelector('[data-geolocation-header]');
        storePromptElement.appendChild(storePromptContent);
        const ctaButtonElement = document.querySelector('[data-geolocation-change-store]');
        ctaButtonElement === null || ctaButtonElement === void 0 ? void 0 : ctaButtonElement.addEventListener('click', () => {
            this.accept(form);
        });
        const stayOnThisStoreElement = document.querySelector('[data-geolocation-stay]');
        stayOnThisStoreElement === null || stayOnThisStoreElement === void 0 ? void 0 : stayOnThisStoreElement.addEventListener('click', () => {
            this.cancel();
        });
        const modalOverlay = this.querySelector('modal-overlay');
        modalOverlay.setAttribute('open', '');
        ctaButtonElement === null || ctaButtonElement === void 0 ? void 0 : ctaButtonElement.focus();
    }
    accept(form) {
        form.submit();
    }
    cancel() {
        const now = new Date();
        const time = now.getTime();
        const expireTime = time + 1000 * 86400 * 14; // 14 days from now
        now.setTime(expireTime);
        document.cookie = `geolocationAccepted=true;expires=${now.toUTCString()}`;
        this.parentNode.removeChild(this);
    }
}
docReady(() => __awaiter(void 0, void 0, void 0, function* () {
    if (document.documentElement.hasAttribute('data-enable-geolocation-pop-up')) {
        yield setGeolocationDataAsync();
        customElements.define('geolocation-prompt', GeolocationPrompt);
    }
}));
